import styled from "styled-components";
import { V3HeadlineH4 } from "../Typography";

export const BlogPostAuthorImageMetadata = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            margin-right: 12px;
        }
    }
`;

export const BlogPostAuthorImage = styled.img`
    width: 50px;
    height: 50px;
    border-radius: 50%;
`;

export const BlogPostAuthorImageName = styled(V3HeadlineH4) <{ isPostPreview?: boolean }>`
    font-weight: 600;
    font-size: ${({ isPostPreview }) => isPostPreview ? "16px" : "18px"};
`;
